const FLORIDA = 'FL';
const ARIZONA = 'AZ';
const NEW_MEXICO = 'NM';

export type UsaProfile = {
    limitsGroup?: Array<Record<string, unknown>>;
    state?: string;
    toValues?: {
        ssn?: string;
        itin?: string;
    };
    occupation?: unknown;
    kycVerified?: boolean;
};

export class UsaService {
    static isNewLimits(profile?: UsaProfile | null): boolean {
        return (profile?.limitsGroup?.length ?? 0) > 1;
    }

    static isUserFromFlorida(profile?: UsaProfile | null): boolean {
        return profile?.state === FLORIDA;
    }

    static isUserFromArizona(profile?: UsaProfile | null): boolean {
        return profile?.state === ARIZONA;
    }

    static isUserFromStateWithOccupation(profile?: UsaProfile | null): boolean {
        return profile?.state === ARIZONA || profile?.state === NEW_MEXICO;
    }

    static hasProvidedSsnOrItin(profile?: UsaProfile | null): boolean {
        return this.hasProvidedSsn(profile) || this.hasProvidedItin(profile);
    }

    static hasProvidedSsn(profile?: UsaProfile | null): boolean {
        return Boolean(profile?.toValues?.ssn);
    }

    static hasProvidedItin(profile?: UsaProfile | null): boolean {
        return Boolean(profile?.toValues?.itin);
    }

    static hasProvidedOccupation(profile?: UsaProfile | null): boolean {
        return Boolean(profile?.occupation);
    }

    static iDologyCheckSuccessful(profile?: UsaProfile | null): boolean {
        return this.hasProvidedSsnOrItin(profile) && Boolean(profile?.kycVerified);
    }
}
